export const engagementMessageVariationsForUcoCampaignId = "/engagement/message_variations_for_uco/:campaign_id";
